import React from "react";
import {ProductImage} from "./ProductImage";
import {SortableContainer, SortableElement} from "react-sortable-hoc";
import type {CatalogProduct, ProductAttribute} from "../types";

// region TypeScript Interfaces
// SortableImage extends ProductAttribute with the secondary-image numeric
// values that ProductImages.tsx populates before passing them in.
interface SortableImageEntry extends ProductAttribute {
    value?: any;
}

interface SortableItemProps {
    attribute: SortableImageEntry;
    index: number;
    product: CatalogProduct;
    catalog?: string;
    partnerId?: string | number;
    uploadUrl: string;
    updateProductState: (attribute: string, value: any) => void;
    disabled?: boolean;
}

interface SortableListProps {
    images: SortableImageEntry[];
    product: CatalogProduct;
    catalog?: string;
    partnerId?: string | number;
    uploadUrl: string;
    updateProductState: (attribute: string, value: any) => void;
    isPrimary: boolean;
    width: string;
    height: string;
    disabled?: boolean;
}

interface SortableImagesProps extends SortableListProps {}
// endregion

const SortableItem = SortableElement((({
                                          attribute, index,
                                          product,
                                          catalog,
                                          partnerId,
                                          uploadUrl,
                                          updateProductState,
                                          disabled
                                      }: SortableItemProps) => {
    const imageExist = product.Attributes[attribute.Name] !== "" && product.Attributes[attribute.Name] !== undefined;
    const imageMetadata = product.Attributes["image_metadata"] !== undefined && product.Attributes["image_metadata"].find((meta: any) => meta.attribute === attribute.Name);

    return (
        <ProductImage product={product}
                      catalog={catalog}
                      partnerId={partnerId}
                      uploadUrl={uploadUrl}
                      key={`${index}-${attribute.Name}`}
                      listkey={index}
                      updateProductState={updateProductState}
                      attribute={attribute}
                      isPrimary={false}
                      imageExist={imageExist}
                      imageMetadata={imageMetadata}
                      label={attribute.FriendlyName}
                      width={"142px"}
                      height={"164px"}
                      disabled={disabled}
        />
    )
}) as any);

const SortableList = SortableContainer((({
                                            images,
                                            product,
                                            catalog,
                                            partnerId,
                                            uploadUrl,
                                            updateProductState,
                                            isPrimary,
                                            width,
                                            height,
                                            disabled
                                        }: SortableListProps) => {
    return (
        <div style={{flex: 1, display: "flex", flexWrap: "wrap", overflow: "auto", gap: "5px"}}>
            {images.map((attribute, index) => (
                <SortableItem
                    key={`item-${index}`}
                    index={index}
                    attribute={attribute}
                    product={product}
                    catalog={catalog}
                    partnerId={partnerId}
                    uploadUrl={uploadUrl}
                    updateProductState={updateProductState}
                    {...({isPrimary, width, height, disabled} as any)}
                />
            ))}
        </div>
    );
}) as any);


export default function SortableImages(props: SortableImagesProps) {
    const {
        images,
        product,
        catalog,
        partnerId,
        uploadUrl,
        updateProductState,
        isPrimary,
        width,
        height,
        disabled
    } = props;

    const SortableListAny = SortableList as any;
    return (
        <SortableListAny
            axis={"xy"}

            useDragHandle={true}
            images={images}
            product={product}
            catalog={catalog}
            partnerId={partnerId}
            uploadUrl={uploadUrl}
            updateProductState={updateProductState}
            isPrimary={isPrimary}
            width={width}
            height={height}
            disabled={disabled}

            onSortEnd={(sortEnd: { oldIndex: number; newIndex: number }, _sortEvent: any) => {
                const currentImage = product.Attributes[images[sortEnd.oldIndex].Name];
                const replaceWithImage = product.Attributes[images[sortEnd.newIndex].Name];

                updateProductState(images[sortEnd.oldIndex].Name, replaceWithImage);
                updateProductState(images[sortEnd.newIndex].Name, currentImage);
            }}
            onSortStart={(_: any, event: any) => event.preventDefault()}
        />
    )
}
